const URL =
  'http://www.secretariasenado.gov.co/senado/basedoc/estatuto_tributario.html';

export { URL };
